import { render } from "./ProgettoAttivoCard.vue?vue&type=template&id=9de644ec&ts=true"
import script from "./ProgettoAttivoCard.vue?vue&type=script&lang=ts"
export * from "./ProgettoAttivoCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__